module.exports = __webpack_public_path__ + "static/logo-b00f7f6ffb4f47a2f0a31e2e8a374522.svg";